import React, { Component } from 'react'
import { Text } from '../../../SPRINTA/atoms/Forms'
import css from './style.css'

const creditCardList = [
    { card: 'visa', test: /^4/, mask: "#### #### #### ####" },
    // { card: 'mastercard', test: /^5/, mask: "#### #### #### ####" },
    { card: 'mastercard', test: /^((2)|(5))/, mask: "#### #### #### ####" },
    { card: 'diners', test: /^((301)|(305)|(36)|(38))/, mask: "#### ###### #####" },
    { card: 'amex', test: /^((34)|(37))/, mask: "#### ###### #####" },
    { card: 'discover', test: /^((6011)|(622)|(64)|(65))/, mask: "#### #### #### ####" },
    { card: 'aura', test: /^(50)/, mask: "####### #######" },
    { card: 'elo', test: /^((636368)|(636369)|(438935)|(504175)|(451416)|(636297)|(5067)|(4576)|(4011)|(506699))/, mask: "#### #### #### ####" },
    { card: 'jcb', test: /^(35)/, mask: "#### #### #### ####" },
    { card: 'hipercard', test: /^((38)|(60))/, mask: "#### #### #### ####" },
]


export default class AdyenForm extends Component {
    state = {
        creditCard: '',
        band: null,
        mask: "###################"
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.defaultValue || nextProps.value) {
            this.setState({
                creditCard: nextProps.value || nextProps.defaultValue
            })
        }
    }
    
    handleChange(e) {
        let val = e.target.value
        let band = null
        let mask = this.state.mask

        creditCardList.forEach(item => {
            if(item['test'].test(val)) {
                band = item['card']
                mask = item['mask']
            }
        })

        this.setState({
            creditCard: val,
            band,
            mask
        })
        
        this.props.handleChange(e)
        this.props.handleChangeCardBanner(band)
    }

    render() {
        const { defaultValue, handleChange, value, handleChangeCardBanner, ...other } = this.props

        return (
            <Text
                handleChange={e => this.handleChange(e)}
                value={this.state.creditCard}
                mask={this.state.mask}
                iconRight={(
                            this.state.band &&
                                <span className={`${css.icon} ${css[`icon-${this.state.band}`]}`} />
                            )}
                { ...other }
            />
        )
    }

}


// WEBPACK FOOTER //
// ./src/App/Components/CreditCardInput/index.js